import React from 'react';
import { Page } from '../../layout';
import { Table } from 'antd';
import PageInstructions from '../../shared/components/PageInstructions';
import { Breadcrumb } from '../../shared/components/breadcrumb/Breadcrumb';

const { Column, ColumnGroup } = Table;

const ReleaseNotesPage = () => {
  const description =
    'The VIP Portal will undergo periodic updates. ' +
    'The latest release notes describing new or modified features will be displayed below.';

  const pageTitle = 'Release Notes';
  const breadcrumbPathItems = [{ name: pageTitle, url: '' }];

  return (
    <Page title={pageTitle} className='release-notes'>
      <Breadcrumb pathItems={breadcrumbPathItems} />

      <PageInstructions title='Release Notes' description={description} />
      {releaseNotes.map((data, i) => (
        <Table
          dataSource={data.notes}
          pagination={false}
          rowKey='item'
          key={i}
          rowClassName='notes-row'
          bordered={true}>
          <ColumnGroup title={data.date}>
            <Column title='Item' dataIndex='item' width='33%' render={tableContentRenderer} />
            <Column
              className='description-column'
              title='Description'
              dataIndex='description'
              render={tableContentRenderer}
            />
          </ColumnGroup>
        </Table>
      ))}
    </Page>
  );
};

const releaseNotes = [
  {
    date: '1 January 2023',
    notes: [
      {
        item: 'Navigation',
        description: `Easily navigate the site using either the left-hand 
          corner menu or upper-left clickable breadcrumbs.`
      },
      {
        item: 'Data Reports',
        description: `View appraisal and performance data for sites within the organization, 
          investigate appraisal trends across industry, 
          or compare appraisal results for sites against industry or the organization.`
      },
      {
        item: 'Search and Filter functionality',
        description: `When searching for a site, filter results by letter, name, 
          FEI or OHT (for FDA). When reviewing appraisal data, 
          filter results by program year, practice area, 
          practice group level, and or OHT, depending on the report.`
      },
      {
        item: 'Supplemental Information',
        description: `
          “More Info” boxes on the left of the screen provide additional information 
          corresponding to the graphs, such as appraisal ID, FEI #, 
          multi-site status, associated OHTs, practice statement, and more.`
      },
      {
        item: 'Download functionality',
        description: `Download any report as a .csv file that can be modified to your individual needs.`
      },
      {
        item: 'Report Management',
        description: `Sponsors have the option to share additional datasets with FDA 
          and/or restrict data access to others in the organization.`
      },
      {
        item: 'Notifications',
        description: `FDA receives in-system notifications when new appraisal or performance data is available, 
          or when a reappraisal rationale has been submitted.`
      },
      {
        item: 'User Management',
        description: `An Organization Admin can view the number of VIP Portal licenses available, 
          see who has been assigned a license, assign licenses to new or existing users, 
          and manage already assigned licenses.`
      },
      {
        item: 'Resources',
        description: `A growing number of resources are linked in a centralized location 
          and organized to help Participants where they are in their continuous improvement journey.`
      },
      {
        item: 'Customer Support',
        description: (
          <>
            A dedicated escalation email (<a href='mailto:VIP@isaca.org'>VIP@isaca.org</a>) has been
            created for VIP Portal troubleshooting so that inquiries are resolved in a timely
            manner.
          </>
        )
      }
    ]
  }
];

const tableContentRenderer = content => <div className='cell-content'>{content}</div>;

export default ReleaseNotesPage;
